import type { VoidFunctionComponent } from 'react';
import cx from 'classnames';
import styles from './StateContextPanel.module.less';

type Props = {
  error: string;
};

const FailedStatePanel: VoidFunctionComponent<Props> = ({
  error,
}) => {
  return (
    <div className={cx(styles.stateContextPanel, styles.failedState)}>
      {error}
    </div>
  );
};

export default FailedStatePanel;
